/** Public environment identities; credentials are never part of this contract. */
export const cashhubFirebaseEnvironments = {
  development: { projectId: "cashhub-app-dev-6fac1f00", apiOrigin: "https://api.dev.cashhub.boemyoung.co.kr", webOrigin: "https://dev.www.cashhub.boemyoung.co.kr", apiServiceAccount: "cashhub-dev-api@cashhub-app-dev-6fac1f00.iam.gserviceaccount.com" },
  production: { projectId: "cashhub-app-6fac1f00", apiOrigin: "https://api.cashhub.boemyoung.co.kr", webOrigin: "https://www.cashhub.boemyoung.co.kr", apiServiceAccount: "cashhub-dev-api@cashhub-app-6fac1f00.iam.gserviceaccount.com" },
} as const

export const firebaseProjectForWeb = (input: { readonly apiBase: string; readonly webOrigin: string; readonly projectId: string; readonly authDomain: string }): string | null => {
  let api: URL
  let web: URL
  try {
    api = new URL(input.apiBase, input.webOrigin)
    web = new URL(input.webOrigin)
  } catch {
    return null
  }
  if (api.username || api.password || api.hash || api.search || web.origin !== input.webOrigin) return null
  const local = ["localhost", "127.0.0.1"].includes(web.hostname)
  const environment = Object.entries(cashhubFirebaseEnvironments).find(
    ([kind, entry]) => input.projectId === entry.projectId && input.authDomain === `${entry.projectId}.firebaseapp.com` && (web.origin === entry.webOrigin || (kind === "development" && local)) && (api.origin === entry.apiOrigin || (api.origin === web.origin && input.apiBase.startsWith("/api"))),
  )?.[1]
  return environment?.projectId ?? null
}
